module.exports = __webpack_public_path__ + "img/ALLOSURVIE_App_Picto_iOS.49882627.svg";